import { SignInFormValues } from "./types";

export const initialValues: SignInFormValues = {
    username: "",
    password: "",
};

export const selectIsLoading = (state: any) => state.auth.isLoading;
export const selectAuthUser = (state: any) => state.auth.user;